import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Icon } from "pepsico-ds";
import "./FloatingAIButton.scss";

const FloatingAIButton = () => {
  const navigate = useNavigate();
  const enableMenu = window.ENABLE_GENAI_MENU; 

  /* istanbul ignore next */
  return (
    enableMenu && (
    <div className="floating-ai-wrapper">
      <button
        className="floating-ai-btn"
        onClick={() => navigate("/ai-assistant")}
        aria-label="floating-ai-btn"
        data-fs-qa="floating-ai-btn"
      >
        <Icon icon="auto_awesome" />
      </button>
      <span className="floating-ai-tooltip">Procurement Hub AI Assistant</span>
    </div>
    )
  );
};

export default FloatingAIButton;
